import Immutable from "immutable";
const LOAD = 'orthoEarningsSending/LOAD';
const LOAD_SUCCESS = 'orthoEarningsSending/LOAD_SUCCESS';
const LOAD_FAIL = 'orthoEarningsSending/LOAD_FAIL';

const initialState = Immutable.fromJS({
    isLoad: false,
    loadErr: null,
    loading: false,
    orthoEarningsSetUp:{},
});
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case LOAD:
            return state
                .set('isLoad', true)
                .set('loadErr', null);

        case LOAD_SUCCESS:
            return state
                .set('isLoad', false)
                .set('loadErr', null)
                .set('orthoEarningsSetUp', action.res);

        case LOAD_FAIL:
            return state
                .set('isLoad', false)
                .set('loadErr', action.error)
                .set('schedule', null);
        default:
            return state;
    }
}

export const getOrthoEarningsSendingSetup = () => async (dispatch, getState, api) => {
    dispatch({ type: LOAD });
    try {
        const resp =  await api.get("ortho/getOrthoEarningsSetUp");
        dispatch({ type: LOAD_SUCCESS, res:resp });
        return resp;
    } catch (err) {
        dispatch({ type: LOAD_FAIL,  error: err.message });
    }

};